<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12">
    <div class="row justify-content-center">
      <div class="col-sm-12 col-xs-12">
        <div class="card-header pb-0 col-sm-12 d-flex mainDiv">
          <div class="col-sm-12 col-xs-12">
            <div
                class="col-sm-12 col-xs-12 titleDiv CertListTitle justify-content-between title-area"
            >
              <div>
                <h3>제품 인증서 연동</h3>
                <h5>QR코드를 스캔하여 제품과 인증서를 연결하세요.<br/>제품의 정품 인증과 추적이 가능합니다.</h5>
              </div>
            </div>
            <div class="card-body px-0 pt-0 pb-2 table-with-search">
              <div class="search-filter-container table-info-filter">
                    <div class="search-filter-row">
                        <div class="search-filter-title">
                            {{ $t('common_searchfilter_keyword') }}
                        </div>
                        <div class="search-filter-content">
                            <div class="mobile-wrap">
                                <a-select
                                    v-model:value="searchFilter.filter"
                                    size="small"
                                    style="width: 150px;"
                                >
                                    <a-select-option value="">{{ $t('hospital_search_all') }}</a-select-option>
                                    <a-select-option value="productGroupId">제품그룹</a-select-option>
                                    <a-select-option value="qrCode">QR코드</a-select-option>
                                </a-select>
                                <a-input 
                                    size="small"
                                    v-model:value="searchFilter.keyword"
                                    @keyup.enter="search"
                                    :placeholder="$t('common_searchfilter_placeholder')"
                                >
                                  <template #prefix>
                                    <i
                                        class="fa-regular fa-magnifying-glass"
                                    />
                                  </template>
                                </a-input>

                            </div>
                            <div class="mobile-wrap">
                                <a-button
                                    class="black"
                                    size="small"
                                    @click="search"
                                >
                                    {{ $t('certificatelist_search') }}
                                </a-button>
                                <a-button
                                    @click="initFilter"
                                    size="small"
                                >
                                {{ $t('common_searchfilter_reset') }}
                                </a-button>
                            </div>
                        </div>
                    </div>
                    <div class="search-filter-row">
                        <div class="search-filter-title">
                            {{ $t('common_searchfilter_period') }}
                        </div>
                        <div class="search-filter-content">
                            <div class="date-filter-container-wrapper is-mobile-only">
                                <div class="date-filter-container ">
                                    <div
                                    class="date-filter-item"
                                    :class="searchFilter.selectedDateFilter === 'all' ? 'selected' : ''"
                                    @click="handleDateFilter('all')"
                                    >
                                    {{ $t('common_total') }}
                                    </div>
                                    <div 
                                    v-for="item in searchFilter.dateFilters.slice(0,1)" 
                                    class="date-filter-item"
                                    :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"  
                                    @click="handleDateFilter(item)"
                                    >
                                    {{ item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${convertMonthAndYearText(item)}` }}
                                    </div>
                                </div>
                                <div class="date-filter-container">
                                    <div 
                                    v-for="item in searchFilter.dateFilters.slice(1,3)" 
                                    class="date-filter-item"
                                    :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"  
                                    @click="handleDateFilter(item)"
                                    >
                                    {{ item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${convertMonthAndYearText(item)}` }}
                                    </div>
                                </div>
                                <div class="date-filter-container" style="width: 100%;">
                                    <div 
                                    v-for="item in searchFilter.dateFilters.slice(3,4)" 
                                    class="date-filter-item"
                                    :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"  
                                    style="width: 100%;border-bottom: 1px solid rgba(0, 0, 0, 0.15);"
                                    @click="handleDateFilter(item)"
                                    >
                                    {{ item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${convertMonthAndYearText(item)}` }}
                                    </div>
                                </div>
                            </div>
                            <div class="date-filter-container is-desktop-tablet">
                                <div
                                    class="date-filter-item"
                                    :class="searchFilter.selectedDateFilter === 'all' ? 'selected' : ''"
                                    @click="handleDateFilter('all')"
                                >
                                    {{ $t('common_total') }}
                                </div>
                                <div 
                                    v-for="item in searchFilter.dateFilters" 
                                    class="date-filter-item"
                                    :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"  
                                    @click="handleDateFilter(item)"
                                >
                                    {{ item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${convertMonthAndYearText(item)}` }}
                                </div>
                            </div>
                            <div class="date-selector-container custom" v-if="searchFilter.selectedDateFilter === 'etc'">
                            <a-range-picker 
                                :allowClear="false" 
                                size="small"
                                :locale="locale" 
                                v-model:value="dateRanges" 
                                @change="search"
                                style="width: 250px; margin-bottom: 10px"
                                @openChange="handleBlur"
                            />
                            </div>
                        </div>
                    </div>
                    <div class="search-filter-row">
                        <div class="search-filter-title">
                            등록 상태
                        </div>
                        <div class="search-filter-content">
                            <a-select
                            v-model:value="searchFilter.linkStatus"
                            @change="handleSelectFilter"
                            size="small"
                            style="width: 150px;"
                            >
                            <a-select-option value="">{{ $t('common_total') }}</a-select-option>
                            <a-select-option value="NOT_USED">미등록</a-select-option>
                            <a-select-option value="USED">등록완료</a-select-option>
                            </a-select>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 table-info-filter">
                    <div class="total-div">
                    <p>
                        {{ $t('common_total') }} <span class="number-highlight">{{ formatCommaNumber(listSize) }}</span>{{ $t('common_case') }}
                    </p>
                    </div>
                    <div class="search-container">
                        <a-select 
                            class="search-select" 
                            v-model:value="rowsPerPage" 
                            @change="handleRowsPerPage"
                            style="width: 150px;"  
                        >
                            <a-select-option :value="10">10{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                            <a-select-option :value="20">20{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                            <a-select-option :value="50">50{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                        </a-select>
                        <a-button 
                            @click="downloadExcelList"
                            type="primary"
                            class="no-mobile"
                        >
                            <template #icon>
                              <i class="fa-solid fa-down-to-bracket"/>
                            </template>
                            {{ $t('common_excel_download') }}
                        </a-button>
                        <a-button 
                            @click="generateQRCode"
                            type="primary"
                            class="generate-qr-button"
                            :loading="generateQRLoading"
                        >
                            <template #icon>
                              <i class="fa-solid fa-qrcode"/>
                            </template>
                            QR코드 생성
                        </a-button>
                    </div>
                </div>
                <a-table class="ant-table-striped expandable-table"
                    size="small"
                    :columns="groupColumns"
                    :data-source="groupedData"
                    :pagination="false"
                    :rowClassName="setRowClassName"
                    :rowKey="record => record.productGroupId"
                    v-if="groupedData.length > 0"
                    v-model:expanded-row-keys="expandedRowKeys"
                    :expand-row-by-click="true"
                >
                    <template #bodyCell="{ column, record }">
                      <template v-if="column.key === 'qrCount'">
                        <span class="qr-count-badge">
                          <i class="fa-solid fa-qrcode" style="margin-right: 4px;"/>
                          {{ record.qrCodes.length }}개
                        </span>
                      </template>
                      <template v-if="column.key === 'usedCount'">
                        <span :class="['usage-status', record.usedCount > 0 ? 'has-used' : 'no-used']">
                          {{ record.usedCount }}/{{ record.qrCodes.length }}
                        </span>
                      </template>
                      <template v-if="column.key === 'linkedProduct'">
                        <span v-if="record.linkedProductName" class="linked-product">
                          {{ record.linkedProductName }}
                        </span>
                        <a-button v-else size="small" type="primary" ghost @click.stop="openLinkProductModal(record)">
                          <i class="fa-solid fa-link" style="margin-right: 4px;"/>
                          제품 연동
                        </a-button>
                      </template>
                      <template v-if="column.key === 'actions'">
                        <a-space>
                          <a-button size="small" @click.stop="showGroupDetail(record)">
                            상세보기
                          </a-button>
                          <a-button size="small" type="primary" @click.stop="downloadGroupQRCodes(record)">
                            <i class="fa-solid fa-download"/>
                          </a-button>
                        </a-space>
                      </template>
                    </template>

                    <!-- 펼치기: 15개 QR 목록 -->
                    <template #expandedRowRender="{ record }">
                      <div class="expanded-qr-list">
                        <div class="expanded-header">
                          <span>QR코드 목록 ({{ record.qrCodes.length }}개)</span>
                          <a-button size="small" @click="downloadGroupQRCodes(record)">
                            <i class="fa-solid fa-download" style="margin-right: 4px;"/>
                            전체 다운로드
                          </a-button>
                        </div>
                        <a-table
                          :columns="qrDetailColumns"
                          :data-source="record.qrCodes"
                          :pagination="false"
                          size="small"
                          :rowKey="qr => qr.qrCode"
                        >
                          <template #bodyCell="{ column, record: qrRecord }">
                            <template v-if="column.key === 'qrCode'">
                              {{ formatQRCodeForInput(qrRecord.qrCode) }}
                            </template>
                            <template v-if="column.key === 'isUsed'">
                              <span :class="['status-chip', qrRecord.isUsed ? 'completed' : 'waiting']">
                                {{ qrRecord.isUsed ? '등록완료' : '미등록' }}
                              </span>
                            </template>
                            <template v-if="column.key === 'registeredInfo'">
                              <span v-if="qrRecord.isUsed && qrRecord.registeredProduct" class="product-code-badge">
                                {{ qrRecord.registeredProduct.productCode }}
                              </span>
                              <span v-else class="text-muted">-</span>
                            </template>
                            <template v-if="column.key === 'actions'">
                              <a-space>
                                <a-button size="small" @click="copySingleQRLink(qrRecord.qrCode)">
                                  <i class="fa-solid fa-link"/>
                                </a-button>
                                <a-button size="small" @click="showQRDetail(qrRecord)">
                                  <i class="fa-solid fa-eye"/>
                                </a-button>
                              </a-space>
                            </template>
                          </template>
                        </a-table>
                      </div>
                    </template>
                </a-table>
                <div class="no-result-container" v-else>
                    <i class="fa-solid fa-exclamation-triangle" />
                    <span>{{ computedNoResultMessage }} </span>
                </div>
            </div>
            <pagination 
              v-if="!$store.state.isLoading && responseData.length > 0"
              :page-info="paginationData"
              page-name="ProductCertificateLink"
              @change-page="paginationHandler"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- QR코드 상세보기 모달 (개별 QR) -->
    <a-modal
      v-model:visible="qrDisplayModal.visible"
      :footer="null"
      width="500px"
      centered
    >
      <template #title>
        <div class="modal-title">QR코드 상세 정보</div>
      </template>
      <div class="qr-detail-modal-content">
        <!-- QR 코드 섹션 -->
        <div class="qr-section">
          <h4 class="qr-section-title">보철재질 QR코드</h4>

          <!-- QR 코드 이미지 -->
          <div class="qr-image-container">
            <img
              :src="qrDisplayModal.qrImageUrl"
              :alt="qrDisplayModal.qrCode"
              class="qr-code-image"
              v-if="qrDisplayModal.qrImageUrl"
            />
            <div class="qr-code-placeholder" v-else>
              <i class="fa-solid fa-qrcode"></i>
            </div>
          </div>

          <!-- QR 코드 텍스트 -->
          <div class="qr-code-text">{{ formatQRCodeForInput(qrDisplayModal.qrCode) }}</div>

          <!-- QR 링크 URL -->
          <div class="qr-link-url">{{ qrDisplayModal.qrLinkUrl }}</div>
        </div>

        <!-- 정보 카드 -->
        <div class="qr-info-card">
          <div class="info-row">
            <span class="info-label">QR코드:</span>
            <span class="info-value">{{ formatQRCodeForInput(qrDisplayModal.qrCode) }}</span>
          </div>

          <div class="info-row">
            <span class="info-label">제품 그룹:</span>
            <span class="info-value">{{ qrDisplayModal.productGroupId || '-' }}</span>
          </div>

          <div class="info-row">
            <span class="info-label">등록 상태:</span>
            <span class="info-value status-badge" :class="qrDisplayModal.isUsed ? 'active' : 'waiting'">
              {{ qrDisplayModal.isUsed ? '등록완료' : '미등록' }}
            </span>
          </div>

          <div class="info-row">
            <span class="info-label">생성일:</span>
            <span class="info-value">{{ qrDisplayModal.createAt }}</span>
          </div>
        </div>

        <!-- 액션 버튼들 -->
        <div class="modal-actions">
          <a-button class="action-button secondary" @click="copyQRLinkUrl">
            <template #icon>
              <i class="fa-solid fa-link"/>
            </template>
            링크 복사
          </a-button>
          <a-button class="action-button primary" @click="downloadSingleQR">
            <template #icon>
              <i class="fa-solid fa-download"/>
            </template>
            QR코드 다운로드
          </a-button>
        </div>

        <!-- 등록된 제품 정보 (등록된 경우에만 표시) -->
        <div class="linked-certificates-section" v-if="qrDisplayModal.isUsed && qrDisplayModal.registeredProduct">
          <div class="linked-certificates-header">
            <h4>등록된 제품 정보</h4>
          </div>
          <div class="qr-info-card">
            <div class="info-row">
              <span class="info-label">고객명:</span>
              <span class="info-value">{{ qrDisplayModal.registeredProduct.customerName || '-' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">연락처:</span>
              <span class="info-value">{{ qrDisplayModal.registeredProduct.customerMobile || '-' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">등록일:</span>
              <span class="info-value">{{ qrDisplayModal.registeredProduct.registeredAt || '-' }}</span>
            </div>
          </div>
        </div>
      </div>
    </a-modal>

    <!-- QR코드 15개 일괄 생성 완료 모달 -->
    <a-modal
      v-model:visible="qrBatchModal.visible"
      :footer="null"
      width="800px"
      centered
    >
      <template #title>
        <div class="modal-title">QR코드 15개 생성 완료</div>
      </template>
      <div class="qr-batch-modal-content">
        <div class="batch-info">
          <div class="batch-info-row">
            <span class="info-label">제품 그룹 ID:</span>
            <span class="info-value highlight">{{ qrBatchModal.productGroupId }}</span>
          </div>
          <div class="batch-info-row">
            <span class="info-label">생성된 QR코드:</span>
            <span class="info-value">{{ qrBatchModal.qrCodes.length }}개</span>
          </div>
          <div class="batch-info-row">
            <span class="info-label">생성일시:</span>
            <span class="info-value">{{ qrBatchModal.createAt }}</span>
          </div>
        </div>

        <!-- QR코드 목록 -->
        <div class="qr-batch-list">
          <div class="qr-batch-list-header">
            <span>생성된 QR코드 목록</span>
            <a-button type="primary" size="small" @click="downloadAllQRCodes" :loading="downloadingAll">
              <template #icon>
                <i class="fa-solid fa-download"/>
              </template>
              전체 다운로드
            </a-button>
          </div>
          <a-table
            :columns="batchQRColumns"
            :data-source="qrBatchModal.qrCodes"
            :pagination="false"
            size="small"
            :scroll="{ y: 400 }"
          >
            <template #bodyCell="{ column, record }">
              <template v-if="column.key === 'actions'">
                <a-space>
                  <a-button size="small" @click="copySingleQRLink(record.qrCode)">
                    <i class="fa-solid fa-link"/>
                  </a-button>
                  <a-button size="small" @click="downloadSingleQRFromBatch(record)">
                    <i class="fa-solid fa-download"/>
                  </a-button>
                </a-space>
              </template>
            </template>
          </a-table>
        </div>

        <div class="modal-actions" style="margin-top: 20px;">
          <a-button class="action-button secondary" @click="qrBatchModal.visible = false">
            닫기
          </a-button>
        </div>
      </div>
    </a-modal>

    <!-- 그룹 상세보기 모달 -->
    <a-modal
      v-model:visible="groupDetailModal.visible"
      :footer="null"
      width="800px"
      centered
    >
      <template #title>
        <div class="modal-title">QR코드 그룹 상세정보</div>
      </template>
      <div class="group-detail-modal-content">
        <!-- 그룹 요약 정보 -->
        <div class="group-summary-card">
          <div class="summary-row">
            <div class="summary-item">
              <span class="label">제품그룹</span>
              <span class="value highlight">{{ groupDetailModal.productGroupId }}</span>
            </div>
            <div class="summary-item">
              <span class="label">생성일</span>
              <span class="value">{{ convertDateTime(groupDetailModal.createAt) }}</span>
            </div>
          </div>
          <div class="summary-row">
            <div class="summary-item">
              <span class="label">전체 QR</span>
              <span class="value">{{ groupDetailModal.qrCodes.length }}개</span>
            </div>
            <div class="summary-item">
              <span class="label">등록현황</span>
              <span class="value" :class="groupDetailModal.usedCount > 0 ? 'text-success' : 'text-warning'">
                {{ groupDetailModal.usedCount }}/{{ groupDetailModal.qrCodes.length }} 등록완료
              </span>
            </div>
          </div>
          <div class="summary-row" v-if="groupDetailModal.linkedProductName">
            <div class="summary-item full">
              <span class="label">연동제품</span>
              <span class="value text-primary">{{ groupDetailModal.linkedProductName }}</span>
            </div>
          </div>
        </div>

        <!-- QR 목록 테이블 -->
        <div class="qr-detail-table-section">
          <div class="section-header">
            <span>QR코드 상세 목록</span>
            <a-button size="small" type="primary" @click="downloadGroupQRCodesFromModal">
              <template #icon>
                <i class="fa-solid fa-download"/>
              </template>
              전체 다운로드
            </a-button>
          </div>
          <a-table
            :columns="groupDetailColumns"
            :data-source="groupDetailModal.qrCodes"
            :pagination="false"
            size="small"
            :scroll="{ y: 350 }"
            :rowKey="record => record.qrCode"
          >
            <template #bodyCell="{ column, record, index }">
              <template v-if="column.key === 'index'">
                {{ index + 1 }}
              </template>
              <template v-if="column.key === 'qrCode'">
                <span class="qr-code-text">{{ formatQRCodeForInput(record.qrCode) }}</span>
              </template>
              <template v-if="column.key === 'isUsed'">
                <span :class="['status-chip', record.isUsed ? 'completed' : 'waiting']">
                  {{ record.isUsed ? '등록완료' : '미등록' }}
                </span>
              </template>
              <template v-if="column.key === 'productCode'">
                <span v-if="record.isUsed && record.registeredProduct" class="product-code-badge">
                  {{ record.registeredProduct.productCode }}
                </span>
                <span v-else class="text-muted">-</span>
              </template>
              <template v-if="column.key === 'registeredAt'">
                <span v-if="record.isUsed && record.registeredProduct">
                  {{ convertDateTime(record.registeredProduct.registeredAt) }}
                </span>
                <span v-else class="text-muted">-</span>
              </template>
              <template v-if="column.key === 'actions'">
                <a-space>
                  <a-button size="small" @click="copySingleQRLink(record.qrCode)">
                    <i class="fa-solid fa-link"/>
                  </a-button>
                  <a-button size="small" @click="showQRDetail(record)">
                    <i class="fa-solid fa-eye"/>
                  </a-button>
                </a-space>
              </template>
            </template>
          </a-table>
        </div>

        <!-- 하단 버튼 -->
        <div class="modal-footer-actions">
          <a-button @click="groupDetailModal.visible = false">닫기</a-button>
          <a-button
            v-if="groupDetailModal.usedCount < groupDetailModal.qrCodes.length"
            type="primary"
            @click="openLinkProductModalFromDetail"
          >
            <template #icon>
              <i class="fa-solid fa-link"/>
            </template>
            제품 등록하기
          </a-button>
        </div>
      </div>
    </a-modal>

    <!-- 제품 등록 모달 (그룹 단위) -->
    <a-modal
      v-model:visible="productRegisterModal.visible"
      :footer="null"
      width="600px"
      centered
      :maskClosable="false"
    >
      <template #title>
        <div class="modal-title">제품 등록</div>
      </template>
      <div class="product-register-modal-content">
        <!-- 그룹 정보 -->
        <div class="qr-info-summary">
          <div class="info-item">
            <span class="label">제품그룹:</span>
            <span class="value highlight">{{ productRegisterModal.productGroupId }}</span>
          </div>
          <div class="info-item">
            <span class="label">등록 대상:</span>
            <span class="value">{{ productRegisterModal.qrCodes.length }}개 QR코드</span>
          </div>
        </div>

        <!-- 입력 방식 선택 탭 -->
        <div class="input-method-tabs">
          <div
            class="tab-item"
            :class="{ active: productRegisterModal.inputMethod === 'manual' }"
            @click="productRegisterModal.inputMethod = 'manual'"
          >
            <i class="fa-solid fa-keyboard" />
            직접 입력
          </div>
          <div
            class="tab-item"
            :class="{ active: productRegisterModal.inputMethod === 'scan', disabled: true }"
            @click="showScanNotAvailable"
          >
            <i class="fa-solid fa-camera" />
            QR 스캔
            <span class="coming-soon">준비중</span>
          </div>
        </div>

        <!-- 직접 입력 폼 -->
        <div class="input-form" v-if="productRegisterModal.inputMethod === 'manual'">
          <div class="form-group">
            <label class="form-label required">제품 코드</label>
            <a-input
              v-model:value="productRegisterModal.productCode"
              placeholder="제품 QR코드 또는 시리얼 번호를 입력하세요"
              size="large"
              @keyup.enter="registerProduct"
            >
              <template #prefix>
                <i class="fa-solid fa-barcode" style="color: #999;"/>
              </template>
            </a-input>
            <p class="form-hint">
              <i class="fa-solid fa-info-circle"/>
              제품에 부착된 QR코드를 스캔하거나 시리얼 번호를 직접 입력하세요
            </p>
          </div>
        </div>

        <!-- QR 스캔 영역 (준비중) -->
        <div class="scan-area" v-if="productRegisterModal.inputMethod === 'scan'">
          <div class="scan-placeholder">
            <i class="fa-solid fa-camera"/>
            <p>카메라 스캔 기능은 준비 중입니다</p>
            <span>html5-qrcode 라이브러리 설치 후 사용 가능</span>
          </div>
        </div>

        <!-- 등록 대상 QR 코드 목록 -->
        <div class="qr-list-section">
          <div class="qr-list-header">
            <span>등록 대상 QR코드 ({{ productRegisterModal.qrCodes.length }}개)</span>
          </div>
          <div class="qr-list-container">
            <div
              v-for="(qr, index) in productRegisterModal.qrCodes"
              :key="qr.qrCode"
              class="qr-list-item"
            >
              <span class="qr-index">{{ index + 1 }}</span>
              <span class="qr-code">{{ formatQRCodeForInput(qr.qrCode) }}</span>
              <span :class="['qr-status', qr.isUsed ? 'registered' : 'pending']">
                {{ qr.isUsed ? '등록완료' : '미등록' }}
              </span>
            </div>
          </div>
        </div>

        <!-- 액션 버튼 -->
        <div class="modal-actions">
          <a-button
            class="action-button secondary"
            @click="closeProductRegisterModal"
          >
            취소
          </a-button>
          <a-button
            type="primary"
            @click="registerProduct"
            :loading="productRegisterModal.loading"
            :disabled="!productRegisterModal.productCode"
          >
            <template #icon>
              <i class="fa-solid fa-check"/>
            </template>
            등록하기
          </a-button>
        </div>
      </div>
    </a-modal>

  </div>
</template>

<script>
import { getAccessToken } from '@/utils/tokenStore';
import { 
  jwtDecoder,
  convertDate,
  oneBtnDialog, 
  convertDateTime, 
  formatCommaNumber,
 } from '../utils/utils';
import NoResult from '../views/components/NoResult.vue';
import Pagination from '@/views/components/Pagination.vue';
import { CertificateCodeGenerator } from '@/utils/codeGenerator';
import locale from 'ant-design-vue/es/date-picker/locale/ko_KR';
import dayjs from "dayjs";
import 'dayjs/locale/ko'

export default {
  name: 'ProductCertificateLink',
  components: {
    NoResult,
    Pagination,
  },
  computed: {
    computedNoResultMessage() {
      if(this.calledApiTimes <= 1) {
        return '등록된 제품 연동 내역이 없습니다.';
      } else {
        return this.$i18n.t('noresult_search');
      }
    },
    // QR코드를 productGroupId로 그룹핑
    groupedData() {
      const groups = {};

      this.responseData.forEach(item => {
        const groupId = item.productGroupId || 'UNKNOWN';

        if (!groups[groupId]) {
          groups[groupId] = {
            productGroupId: groupId,
            qrCodes: [],
            usedCount: 0,
            linkedProductId: null,
            linkedProductName: null,
            createAt: item.createAt,
          };
        }

        groups[groupId].qrCodes.push(item);
        if (item.isUsed) {
          groups[groupId].usedCount++;
        }
      });

      // 배열로 변환하고 생성일 기준 내림차순 정렬
      const sortedGroups = Object.values(groups).sort((a, b) => {
        return new Date(b.createAt) - new Date(a.createAt);
      });

      // 각 그룹의 QR코드에 index 추가
      sortedGroups.forEach(group => {
        group.qrCodes.forEach((qr, idx) => {
          qr.index = idx + 1;
        });
      });

      return sortedGroups;
    },
  },
  data() {
    const page = this;
    return {
      locale,
      dateRanges :[],
      formatCommaNumber,
      convertDateTime,
      isInputFocused: false,
      // 목록 받아오는 변수
      responseData: [],
      
      // 페이지네이션 관련 변수
      previousCondition: '',
      condition: '',
      calledApiTimes: 0,      

      searchFilter: {
        filter: '',
        keyword: '',
        linkStatus: '',
        startAt: null,
        endAt: null,
        selectedDateFilter: 'all',
        dateFilters: [3, 12, 36, 'etc'],
      },
      
      // QR 생성 관련
      generateQRLoading: false,
      downloadingAll: false,

      // 그룹 테이블 관련
      expandedRowKeys: [],

      // 그룹 테이블 컬럼 (메인 테이블)
      groupColumns: [
        { key: 'productGroupId', title: '제품그룹', dataIndex: 'productGroupId', align: 'start', width: '20%' },
        { key: 'qrCount', title: 'QR개수', dataIndex: 'qrCount', align: 'center', width: '12%' },
        { key: 'usedCount', title: '등록현황', dataIndex: 'usedCount', align: 'center', width: '12%' },
        { key: 'linkedProduct', title: '연동제품', dataIndex: 'linkedProduct', align: 'start', width: '25%' },
        {
          key: 'createAt',
          title: '생성일',
          dataIndex: 'createAt',
          align: 'center',
          width: '15%',
          customRender: ({text, record}) => convertDateTime(record.createAt),
        },
        { key: 'actions', title: '관리', dataIndex: 'actions', align: 'center', width: '16%' },
      ],

      // 펼치기 내부 QR 목록 컬럼
      qrDetailColumns: [
        { key: 'index', title: '번호', dataIndex: 'index', align: 'center', width: '8%' },
        { key: 'qrCode', title: 'QR코드', dataIndex: 'qrCode', align: 'start', width: '25%' },
        { key: 'isUsed', title: '등록상태', dataIndex: 'isUsed', align: 'center', width: '15%' },
        { key: 'registeredInfo', title: '제품코드', dataIndex: 'registeredInfo', align: 'start', width: '30%' },
        { key: 'actions', title: '관리', dataIndex: 'actions', align: 'center', width: '22%' },
      ],

      // QR코드 상세보기 모달 (개별 QR)
      qrDisplayModal: {
        visible: false,
        qrCode: '',
        qrImageUrl: '',
        qrLinkUrl: '',
        createAt: '',
        productGroupId: '',
        isUsed: false,
        registeredProduct: null,
      },

      // QR코드 15개 일괄 생성 모달
      qrBatchModal: {
        visible: false,
        productGroupId: '',
        qrCodes: [],
        createAt: '',
      },

      // 제품 등록 모달 (그룹 단위 등록)
      productRegisterModal: {
        visible: false,
        productGroupId: '',
        qrCodes: [], // 그룹에 속한 15개 QR코드 목록
        inputMethod: 'manual', // 'manual' | 'scan'
        productCode: '',
        loading: false,
      },

      // 그룹 상세보기 모달
      groupDetailModal: {
        visible: false,
        productGroupId: '',
        qrCodes: [],
        usedCount: 0,
        createAt: '',
        linkedProductName: null,
      },

      // 그룹 상세보기 테이블 컬럼
      groupDetailColumns: [
        { key: 'index', title: '번호', dataIndex: 'index', align: 'center', width: '8%' },
        { key: 'qrCode', title: 'QR코드', dataIndex: 'qrCode', align: 'start', width: '22%' },
        { key: 'isUsed', title: '등록상태', dataIndex: 'isUsed', align: 'center', width: '12%' },
        { key: 'productCode', title: '제품코드', dataIndex: 'productCode', align: 'start', width: '20%' },
        { key: 'registeredAt', title: '등록일시', dataIndex: 'registeredAt', align: 'center', width: '20%' },
        { key: 'actions', title: '관리', dataIndex: 'actions', align: 'center', width: '18%' },
      ],

      // 일괄 생성 QR 목록 테이블 컬럼
      batchQRColumns: [
        { key: 'index', title: '번호', dataIndex: 'index', align: 'center', width: '10%' },
        { key: 'qrCode', title: 'QR코드', dataIndex: 'qrCode', align: 'start' },
        { key: 'qrLinkUrl', title: 'URL', dataIndex: 'qrLinkUrl', align: 'start', ellipsis: true },
        { key: 'actions', title: '관리', dataIndex: 'actions', align: 'center', width: '15%' },
      ],

      columns:[
            {
                key: 'index', title: '번호', dataIndex: 'index', align: 'center', width: "5%",
            },
            {
                key: 'productGroupId', title: '제품그룹', dataIndex: 'productGroupId', align: 'start', width: "12%",
                customRender: ({text, record}) => {
                    return record.productGroupId || '-';
                },
            },
            {
                key: 'qrCode', title: 'QR코드', dataIndex: 'qrCode', align: 'start', width: "15%",
                customRender: ({text, record}) => {
                    return this.formatQRCodeForInput(record.qrCode);
                },
            },
            {
                key: 'qrLinkUrl', title: 'QR링크', dataIndex: 'qrLinkUrl', align: 'start', ellipsis: true,
                customRender: ({text, record}) => {
                    return CertificateCodeGenerator.generateQRLinkUrl(record.qrCode);
                },
            },
            {
                key: 'isUsed', title: '등록상태', dataIndex: 'isUsed', align: 'center', width: "10%",
                customRender: ({text, record}) => {
                    const isUsed = record.isUsed || false;
                    const statusText = isUsed ? '등록완료' : '미등록';
                    const statusClass = isUsed ? 'completed' : 'waiting';

                    return (
                        <div class="status-chip-wrap">
                            <div
                            className={`status-chip ${statusClass}`}
                            >
                            { statusText }
                            </div>
                        </div>
                    )
                },
            },
            {
                key: 'createAt', title: '생성일', dataIndex: 'createAt', align: 'center', width: "12%",
                customRender: ({text, record}) => {
                    return convertDateTime(record.createAt)
                },
            },
            {
                key: 'actions', title: '관리', dataIndex: 'actions', align: 'center', width: "10%",
                customRender: ({text, record}) => {
                    return (
                        <a-button
                            type="primary"
                            size="small"
                            onClick={(event) => {
                                event.stopPropagation();
                                this.showQRDetail(record);
                            }}
                        >
                            상세보기
                        </a-button>
                    )
                },
            },
        ],
      
      // 연동 정보 테이블 컬럼
      linkInfoColumns: [
        {
          key: 'index', title: '번호', dataIndex: 'index', align: 'center', width: '8%',
        },
        {
          key: 'productType', title: '구분', dataIndex: 'productType', align: 'center', width: '10%',
        },
        {
          key: 'customerName', title: '시술자명', dataIndex: 'customerName', align: 'start', width: '15%',
        },
        {
          key: 'customerMobile', title: '연락처', dataIndex: 'customerMobile', align: 'start', width: '15%',
          customRender: ({text, record}) => {
            const mobile = record.customerMobile || '';
            // 010-1234-5678 형식으로 포맷팅
            if (mobile.length === 11) {
              return `${mobile.slice(0,3)}-${mobile.slice(3,7)}-${mobile.slice(7)}`;
            }
            return mobile;
          },
        },
        {
          key: 'itemNames', title: '제품명', dataIndex: 'itemNames', align: 'start', width: '30%',
          customRender: ({text, record}) => {
            const items = record.itemNames || [];
            return items.join(', ') || '-';
          },
        },
        {
          key: 'surgeryAt', title: '수술/시술일', dataIndex: 'surgeryAt', align: 'center', width: '12%',
          customRender: ({text, record}) => {
            return record.surgeryAt ? convertDate(record.surgeryAt) : '-';
          },
        },
        {
          key: 'createAt', title: '발행일', dataIndex: 'createAt', align: 'center', width: '12%',
          customRender: ({text, record}) => {
            return record.createAt ? convertDate(record.createAt) : '-';
          },
        },
      ],
      
      onRowClick(record, rowIndex) {
          return {
              onClick: event => {
                  // 행 클릭 시 상세 정보 표시 또는 편집 모달 열기
                  console.log('제품 연동 상세:', record);
              },
          };
      },
      listSize: 0,
      rowsPerPage: 10, 
      paginationData: {
        currentPage: 1, 
        totalPages: 0,
      },
      companyId: '',
      
    };
  },
  created() {
    this.companyId = jwtDecoder(getAccessToken());
  },
  async mounted() {
    const obj = {};
    obj.page = this.paginationData.currentPage;
    this.paginationHandler(obj);
  },
  methods: {
    setRowClassName(record){
      return 'hover-pointer';
    },
    convertDate,
    handleBlur(open) {
      console.log('blur', open)
    },
    async paginationHandler(childPassParam) {
      this.paginationData.currentPage = childPassParam.page;
      await this.getProductLinkList();    
    },
    
    // 주요 API
    async getProductLinkList() {
      const obj = {};
      obj.page = this.paginationData.currentPage;
      obj.limit = this.rowsPerPage;
      obj.search = this.searchFilter.filter;
      obj.condition = this.searchFilter.keyword;
      
      if(this.dateRanges?.length ==2){
        obj.startAt = dayjs(this.dateRanges[0]).format("YYYYMMDD");
        obj.endAt = dayjs(this.dateRanges[1]).format("YYYYMMDD");
      }else{
        obj.startAt = null;
        obj.endAt = null;
      }
      
      obj.linkStatus = this.searchFilter.linkStatus;
      this.$store.commit('setIsLoading', true);
      
      try {
        // TODO: 실제 API 엔드포인트로 변경 필요
        // const response = await this.$apiInstance.post(`/product-certificate-links`, obj);
        
        // 임시 더미 데이터 (새로운 구조: QR 1개 = 제품 1회 등록, 제품 1개 = QR 15개)
        const dummyDocs = [];
        const createAtGroup1 = new Date().toISOString();
        const createAtGroup2 = new Date(Date.now() - 172800000).toISOString();

        // 제품그룹 PG-001: 15개 QR (모두 미등록)
        for (let i = 0; i < 15; i++) {
          dummyDocs.push({
            id: `pg1-${i + 1}`,
            qrCode: `DM${String.fromCharCode(65 + i)}${Math.random().toString(36).substring(2, 9).toUpperCase()}`,
            productGroupId: 'PG-001',
            isUsed: false,
            registeredProduct: null,
            createAt: createAtGroup1,
          });
        }

        // 제품그룹 PG-002: 15개 QR (3개 등록됨)
        const registeredNames = ['김철수', '이영희', '박민수'];
        const registeredMobiles = ['01012345678', '01087654321', '01055556666'];
        for (let i = 0; i < 15; i++) {
          const isUsed = i < 3; // 첫 3개만 등록됨
          dummyDocs.push({
            id: `pg2-${i + 1}`,
            qrCode: `DM${String.fromCharCode(80 + i)}${Math.random().toString(36).substring(2, 9).toUpperCase()}`,
            productGroupId: 'PG-002',
            isUsed: isUsed,
            registeredProduct: isUsed ? {
              customerName: registeredNames[i],
              customerMobile: registeredMobiles[i],
              registeredAt: new Date(Date.now() - (i + 1) * 86400000).toISOString(),
            } : null,
            createAt: createAtGroup2,
          });
        }

        const dummyResponse = {
          status: 200,
          data: {
            docs: dummyDocs,
            totalDocs: dummyDocs.length,
            totalPages: 1,
          }
        };
        
        const response = dummyResponse;
        
        if (response.status === 200 || response.status === 201) {
          this.calledApiTimes ++;
          if(response.data.docs) {
            this.responseData = response.data.docs;
          } else {
            this.responseData = [];
          }
          this.listSize = response.data.totalDocs;
          
          for (let i = 0; i < this.responseData.length; i++) {
            this.responseData[i].index =
              this.listSize - i - (this.paginationData.currentPage - 1) * this.rowsPerPage;
          }

          this.paginationData.totalPages = response.data.totalPages;
          this.$store.commit('setIsLoading', false);
        }
      } catch (error) {
        console.log(error);
        this.$store.commit('setIsLoading', false);
        await oneBtnDialog('제품 연동 목록 조회 실패', '제품 연동 목록을 가져오는데 실패했습니다.', false);
      }
    },

    async downloadExcelList() {
      if(this.responseData.length === 0) {
        await oneBtnDialog('다운로드 불가','다운로드할 데이터가 없습니다.', false);
        return;
      }
      
      const formattedDate = dayjs().format("YYYYMMDD");

      const obj = {};
      obj.search = this.searchFilter.filter;
      obj.condition = this.searchFilter.keyword;
      
      if (this.dateRanges?.length == 2) {
        obj.startAt = dayjs(this.dateRanges[0]).format("YYYYMMDD");
        obj.endAt = dayjs(this.dateRanges[1]).format("YYYYMMDD");
      } else {
        obj.startAt = null
        obj.endAt = null
      }
      
      try {
        this.$store.commit('setIsLoading', true);
        // TODO: 실제 엑셀 다운로드 API로 변경 필요
        // const response = await this.$apiInstance.post(`/product-certificate-links/excel`, obj, {
        //   headers: { 'Content-Type': 'application/json' },
        //   responseType: 'blob',
        // });

        // 임시로 성공 메시지만 표시
        await oneBtnDialog('다운로드 완료', '제품 연동 목록이 다운로드되었습니다.', false);
        this.$store.commit('setIsLoading', false);
      } catch (error) {
        this.$store.commit('setIsLoading', false);
        console.error('error: ', error);
        await oneBtnDialog('다운로드 실패', '엑셀 다운로드에 실패했습니다.', false);
      }
    },

    // QR 생성 관련 메서드 (15개 일괄 생성)
    async generateQRCode() {
      this.generateQRLoading = true;

      try {
        const QR_COUNT = 15;
        const createAt = new Date().toISOString();

        // 제품 그룹 ID 생성 (고유 식별자)
        const productGroupId = `PG-${Date.now().toString(36).toUpperCase()}`;

        // 15개 QR 코드 생성
        const qrCodes = [];
        for (let i = 0; i < QR_COUNT; i++) {
          const qrCode = await this.generateUniqueQRCode();
          const qrLinkUrl = CertificateCodeGenerator.generateQRLinkUrl(qrCode);

          qrCodes.push({
            index: i + 1,
            qrCode: qrCode,
            qrLinkUrl: qrLinkUrl,
            productGroupId: productGroupId,
            isUsed: false,
            registeredProduct: null,
            createAt: createAt,
          });
        }

        // TODO: 실제 API 호출로 변경 필요
        // const response = await this.$apiInstance.post('/qr-codes/batch-create', {
        //   productGroupId,
        //   qrCodes: qrCodes.map(qr => qr.qrCode),
        // });

        // 임시로 로컬 데이터에 추가
        qrCodes.forEach((qrData, idx) => {
          this.responseData.unshift({
            ...qrData,
            id: `${Date.now()}-${idx}`,
          });
        });
        this.listSize += QR_COUNT;

        // 인덱스 재계산
        for (let i = 0; i < this.responseData.length; i++) {
          this.responseData[i].index =
            this.listSize - i - (this.paginationData.currentPage - 1) * this.rowsPerPage;
        }

        // 15개 QR코드 일괄 생성 모달 열기
        this.qrBatchModal = {
          visible: true,
          productGroupId: productGroupId,
          qrCodes: qrCodes,
          createAt: convertDateTime(createAt),
        };

        this.$message.success(`QR코드 ${QR_COUNT}개가 생성되었습니다.`);

      } catch (error) {
        console.error('QR코드 생성 실패:', error);
        await oneBtnDialog('생성 실패', 'QR코드 생성에 실패했습니다.', false);
      } finally {
        this.generateQRLoading = false;
      }
    },

    async generateUniqueQRCode() {
      let qrCode;
      let attempts = 0;
      const maxAttempts = 10;

      do {
        // 제조사별 고유 코드 생성 (현재는 기본값 'DM' 사용, 실제로는 로그인한 제조사 코드 사용)
        const manufacturerCode = this.getManufacturerCode();
        qrCode = CertificateCodeGenerator.generateCode(manufacturerCode);
        
        // 표시용 형식으로 정규화 (하이픈 없음)
        qrCode = CertificateCodeGenerator.formatCodeForDisplay(qrCode);
        
        attempts++;
        
        // 로컬 데이터에서 중복 체크 (실제로는 DB에서 체크)
        const exists = this.responseData.some(item => 
          CertificateCodeGenerator.formatCodeForDisplay(item.qrCode) === qrCode
        );
        
        if (!exists) {
          return qrCode;
        }
        
        if (attempts >= maxAttempts) {
          throw new Error('고유 QR코드 생성 실패: 최대 시도 횟수 초과');
        }
      } while (true);
    },

    /**
     * 현재 로그인한 제조사의 코드 반환
     * @returns {string} 제조사 코드 (2자리 대문자)
     */
    getManufacturerCode() {
      // TODO: 실제로는 JWT 토큰이나 사용자 정보에서 제조사 코드를 가져와야 함
      // 현재는 기본값으로 'DM' (덴탈맥스) 사용
      return 'DM';
    },

    /**
     * QR 코드에서 제조사 코드 추출
     * @param {string} qrCode QR 코드
     * @returns {string} 제조사 코드 (2자리)
     */
    extractManufacturerCode(qrCode) {
      return CertificateCodeGenerator.extractManufacturerCode(qrCode) || '-';
    },

    /**
     * QR 코드에서 시리얼 코드 추출
     * @param {string} qrCode QR 코드
     * @returns {string} 시리얼 코드 (8자리)
     */
    extractSerialCode(qrCode) {
      return CertificateCodeGenerator.extractSerialCode(qrCode) || '-';
    },

    /**
     * QR 코드를 표시용 형식으로 포맷 (하이픈 없음)
     * @param {string} qrCode QR 코드
     * @returns {string} 표시용 QR 코드
     */
    formatQRCodeForDisplay(qrCode) {
      return CertificateCodeGenerator.formatCodeForDisplay(qrCode);
    },

    /**
     * QR 코드를 입력용 형식으로 포맷 (하이픈 포함)
     * @param {string} qrCode QR 코드
     * @returns {string} 입력용 QR 코드
     */
    formatQRCodeForInput(qrCode) {
      return CertificateCodeGenerator.formatCodeForInput(qrCode);
    },

    async copyQRLinkUrl() {
      try {
        await navigator.clipboard.writeText(this.qrDisplayModal.qrLinkUrl);
        this.$message.success('QR링크 URL이 클립보드에 복사되었습니다.');
      } catch (error) {
        console.error('클립보드 복사 실패:', error);
        this.$message.error('클립보드 복사에 실패했습니다.');
      }
    },

    // 개별 QR 링크 복사 (일괄 생성 모달에서 사용)
    async copySingleQRLink(qrCode) {
      try {
        const qrLinkUrl = CertificateCodeGenerator.generateQRLinkUrl(qrCode);
        await navigator.clipboard.writeText(qrLinkUrl);
        this.$message.success('QR링크가 클립보드에 복사되었습니다.');
      } catch (error) {
        console.error('클립보드 복사 실패:', error);
        this.$message.error('클립보드 복사에 실패했습니다.');
      }
    },

    // 개별 QR 다운로드 (상세보기 모달에서 사용)
    async downloadSingleQR() {
      try {
        const qrImageUrl = this.qrDisplayModal.qrImageUrl;
        const qrCode = this.qrDisplayModal.qrCode;
        await this.downloadQRImage(qrImageUrl, `QR_${qrCode}.png`);
        this.$message.success('QR코드가 다운로드되었습니다.');
      } catch (error) {
        console.error('다운로드 실패:', error);
        this.$message.error('다운로드에 실패했습니다.');
      }
    },

    // 개별 QR 다운로드 (일괄 생성 모달에서 사용)
    async downloadSingleQRFromBatch(record) {
      try {
        const qrImageUrl = await CertificateCodeGenerator.generateQRImageUrl(record.qrCode, 200);
        await this.downloadQRImage(qrImageUrl, `QR_${record.qrCode}.png`);
        this.$message.success('QR코드가 다운로드되었습니다.');
      } catch (error) {
        console.error('다운로드 실패:', error);
        this.$message.error('다운로드에 실패했습니다.');
      }
    },

    // 전체 QR 다운로드 (15개 순차 다운로드)
    async downloadAllQRCodes() {
      this.downloadingAll = true;
      try {
        for (let i = 0; i < this.qrBatchModal.qrCodes.length; i++) {
          const qr = this.qrBatchModal.qrCodes[i];
          const qrImageUrl = await CertificateCodeGenerator.generateQRImageUrl(qr.qrCode, 200);
          await this.downloadQRImage(qrImageUrl, `QR_${qr.index}_${qr.qrCode}.png`);
          // 다운로드 간 약간의 딜레이 (브라우저가 여러 다운로드를 처리할 수 있도록)
          await new Promise(resolve => setTimeout(resolve, 300));
        }
        this.$message.success(`${this.qrBatchModal.qrCodes.length}개 QR코드가 다운로드되었습니다.`);
      } catch (error) {
        console.error('전체 다운로드 실패:', error);
        this.$message.error('일부 QR코드 다운로드에 실패했습니다.');
      } finally {
        this.downloadingAll = false;
      }
    },

    // QR 이미지 다운로드 헬퍼
    async downloadQRImage(imageUrl, fileName) {
      const link = document.createElement('a');
      link.href = imageUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    // QR 상세보기 모달 표시 (개별 QR)
    async showQRDetail(record) {
      try {
        // QR 코드 이미지 및 링크 생성
        const qrLinkUrl = CertificateCodeGenerator.generateQRLinkUrl(record.qrCode);
        const qrImageUrl = await CertificateCodeGenerator.generateQRImageUrl(record.qrCode, 200);

        // QR 상세 정보 모달 표시
        this.qrDisplayModal = {
          visible: true,
          qrCode: record.qrCode,
          qrImageUrl: qrImageUrl,
          qrLinkUrl: qrLinkUrl,
          createAt: convertDateTime(record.createAt),
          productGroupId: record.productGroupId || '',
          isUsed: record.isUsed || false,
          registeredProduct: record.registeredProduct || null,
        };

      } catch (error) {
        console.error('상세보기 실패:', error);
        this.$message.error('상세보기에 실패했습니다.');
      }
    },

    // 더미 연동 인증서 데이터 생성
    generateDummyLinkedCertificates(count) {
      const dummyData = [];
      const names = ['김철수', '이영희', '박민수', '최지영', '정다은'];
      const mobiles = ['01012345678', '01087654321', '01055556666', '01077778888', '01099990000'];
      const products = [
        ['LUXEN Zirconia #44,45,46'],
        ['LUXEN 5G Smile #45,47'],
        ['LUXEN 1100 Enamel #31,33,34,35'],
        ['Super Line (FXS4016) #11'],
        ['LUXEN Zirconia #12,13']
      ];
      
      for (let i = 0; i < count; i++) {
        dummyData.push({
          subCampaignId: `2025101951656566_${Math.random().toString(36).substr(2, 9)}`,
          issueMethod: "single",
          createAt: new Date(Date.now() - (i * 86400000)).toISOString(), // i일 전
          productType: "보철",
          groups: ["덴탈맥스"],
          itemNames: products[i % products.length],
          productCodes: ["간편발행"],
          surgeryAt: new Date(Date.now() - ((i + 1) * 86400000)).toISOString(), // i+1일 전
          issueStatus: "send-biz",
          customerName: names[i % names.length],
          customerMobile: mobiles[i % mobiles.length],
          customerId: `customer_${Math.random().toString(36).substr(2, 9)}`,
          deliveryOptions: {}
        });
      }
      
      return dummyData;
    },

    async search() {
      if(!await this.validateSearchFilter()) return;
      
      // QR코드 검색 시 하이픈 포함/제외 모두 처리
      if (this.searchFilter.filter === 'qrCode' && this.searchFilter.keyword) {
        this.searchFilter.keyword = CertificateCodeGenerator.formatCodeForDisplay(this.searchFilter.keyword);
      }
      
      this.paginationData.currentPage = 1;
      await this.getProductLinkList();
    },
    
    async initFilter() {
      this.dateRanges = [];
      this.searchFilter = {
        filter: '',
        keyword: '',
        linkStatus: '',
        startAt: null,
        endAt: null,
        selectedDateFilter: 'all',
        dateFilters: [3, 12, 36, 'etc'],
      }
      await this.getProductLinkList();
    },
    
    handleSelectFilter() {
      this.paginationData.currentPage = 1;
      this.search();
    },
    
    handleDateFilter(value) {
      console.log('handle', value)
      this.paginationData.currentPage = 1;
      if(value === this.searchFilter.selectedDateFilter) return;
      
      this.searchFilter.selectedDateFilter = value;
      if (value === 'all') {
        this.searchFilter.startAt = null;
        this.searchFilter.endAt = null;
      } else {
        this.searchFilter.startAt = this.getPastDatesInUnixTime(value);
        this.searchFilter.endAt = dayjs().valueOf();
      }
      if(this.searchFilter.startAt !== null){
        this.dateRanges[0] = dayjs(this.searchFilter.startAt)
      }else{
        this.dateRanges = [];
      }
      if(this.searchFilter.endAt !== null){
        this.dateRanges[1] = dayjs(this.searchFilter.endAt)
      }else{
        this.dateRanges = [];
      }
      this.search();
    },
    
    getCurrentUnixTime() {
      return dayjs().valueOf();
    },
    
    getPastDatesInUnixTime(value) {
      switch(value) {
        case 3:
          return dayjs().subtract(3, 'month').valueOf();
        case 12:
          return dayjs().subtract(12, 'month').valueOf();
        case 36:
          return dayjs().subtract(36, 'month').valueOf();
        default:
          return dayjs().valueOf();
      }
    },
    
    async validateSearchFilter() {
      if(this.searchFilter.startAt && !this.searchFilter.endAt) {
        return false;
      }
      if(this.searchFilter.startAt > this.searchFilter.endAt) {
        await oneBtnDialog('날짜 오류', '시작일이 종료일보다 클 수 없습니다.');
        return false;
      }
      return true;
    },
    
    convertMonthAndYearText(input) {
      if(input < 12) return `${input}${this.$i18n.t('common_searchfilter_month')}`;
      return `${input / 12}${this.$i18n.t('common_searchfilter_year')}`;
    },

    async handleRowsPerPage() {
      this.paginationData.currentPage = 1;
      await this.getProductLinkList();
    },

    // 그룹 테이블 펼치기/접기 핸들러
    handleExpandedRowsChange(expandedKeys) {
      this.expandedRowKeys = expandedKeys;
    },

    // 행 클릭 시 펼치기/접기 토글
    toggleRowExpand(productGroupId) {
      const index = this.expandedRowKeys.indexOf(productGroupId);
      if (index > -1) {
        // 접기 - 새 배열로 교체
        this.expandedRowKeys = this.expandedRowKeys.filter(key => key !== productGroupId);
      } else {
        // 펼치기 - 새 배열로 교체
        this.expandedRowKeys = [...this.expandedRowKeys, productGroupId];
      }
    },

    // 그룹 상세보기 모달 열기
    showGroupDetail(record) {
      this.groupDetailModal = {
        visible: true,
        productGroupId: record.productGroupId,
        qrCodes: record.qrCodes,
        usedCount: record.usedCount,
        createAt: record.createAt,
        linkedProductName: record.linkedProductName,
      };
    },

    // 그룹 상세보기 모달에서 전체 다운로드
    async downloadGroupQRCodesFromModal() {
      const { qrCodes, productGroupId } = this.groupDetailModal;
      this.downloadingAll = true;
      try {
        for (let i = 0; i < qrCodes.length; i++) {
          const qr = qrCodes[i];
          const qrImageUrl = await CertificateCodeGenerator.generateQRImageUrl(qr.qrCode, 200);
          await this.downloadQRImage(qrImageUrl, `QR_${productGroupId}_${i + 1}_${qr.qrCode}.png`);
          await new Promise(resolve => setTimeout(resolve, 300));
        }
        this.$message.success(`${qrCodes.length}개 QR코드가 다운로드되었습니다.`);
      } catch (error) {
        console.error('그룹 QR 다운로드 실패:', error);
        this.$message.error('일부 QR코드 다운로드에 실패했습니다.');
      } finally {
        this.downloadingAll = false;
      }
    },

    // 그룹 상세보기 모달에서 제품 등록 모달 열기
    openLinkProductModalFromDetail() {
      const { productGroupId, qrCodes, usedCount } = this.groupDetailModal;

      if (usedCount === qrCodes.length) {
        this.$message.warning('이 그룹의 모든 QR코드가 이미 등록되어 있습니다.');
        return;
      }

      // 제조사 코드 자동입력 (수기 입력 편의성)
      const manufacturerPrefix = this.getManufacturerCode() + '-';

      // 상세보기 모달은 열어둔 채로 제품 등록 모달 열기
      this.productRegisterModal = {
        visible: true,
        productGroupId: productGroupId,
        qrCodes: qrCodes,
        inputMethod: 'manual',
        productCode: manufacturerPrefix, // 제조사 코드 자동완성
        loading: false,
      };
    },

    // 그룹 전체 QR 다운로드
    async downloadGroupQRCodes(record) {
      this.downloadingAll = true;
      try {
        for (let i = 0; i < record.qrCodes.length; i++) {
          const qr = record.qrCodes[i];
          const qrImageUrl = await CertificateCodeGenerator.generateQRImageUrl(qr.qrCode, 200);
          await this.downloadQRImage(qrImageUrl, `QR_${record.productGroupId}_${i + 1}_${qr.qrCode}.png`);
          // 다운로드 간 약간의 딜레이
          await new Promise(resolve => setTimeout(resolve, 300));
        }
        this.$message.success(`${record.qrCodes.length}개 QR코드가 다운로드되었습니다.`);
      } catch (error) {
        console.error('그룹 QR 다운로드 실패:', error);
        this.$message.error('일부 QR코드 다운로드에 실패했습니다.');
      } finally {
        this.downloadingAll = false;
      }
    },

    // 제품 연동 모달 열기 (그룹 단위)
    openLinkProductModal(record) {
      // 이미 모든 QR이 등록된 경우
      if (record.usedCount === record.qrCodes.length) {
        this.$message.warning('이 그룹의 모든 QR코드가 이미 등록되어 있습니다.');
        return;
      }

      // 제조사 코드 자동입력 (수기 입력 편의성)
      const manufacturerPrefix = this.getManufacturerCode() + '-';

      this.productRegisterModal = {
        visible: true,
        productGroupId: record.productGroupId,
        qrCodes: record.qrCodes, // 그룹에 속한 15개 QR코드 전체
        inputMethod: 'manual',
        productCode: manufacturerPrefix, // 제조사 코드 자동완성
        loading: false,
      };
    },

    // 제품 등록 모달 닫기
    closeProductRegisterModal() {
      this.productRegisterModal.visible = false;
      this.productRegisterModal.productCode = '';
    },

    // QR 스캔 미지원 알림
    showScanNotAvailable() {
      this.$message.info('카메라 스캔 기능은 준비 중입니다. 직접 입력을 이용해주세요.');
    },

    // 제품 등록 처리 (그룹 전체 등록)
    async registerProduct() {
      const { productGroupId, qrCodes, productCode } = this.productRegisterModal;

      if (!productCode || !productCode.trim()) {
        this.$message.warning('제품 코드를 입력해주세요.');
        return;
      }

      this.productRegisterModal.loading = true;

      try {
        // TODO: 실제 API 호출
        // const response = await this.$apiInstance.post('/product-certificate-links/register-group', {
        //   productGroupId: productGroupId,
        //   productCode: productCode.trim(),
        // });

        // 임시로 로컬 데이터 업데이트 - 그룹의 모든 QR 코드를 동일한 제품 코드로 등록
        const registeredAt = new Date().toISOString();
        let registeredCount = 0;

        qrCodes.forEach(qr => {
          const targetIndex = this.responseData.findIndex(item => item.qrCode === qr.qrCode);
          if (targetIndex !== -1 && !this.responseData[targetIndex].isUsed) {
            this.responseData[targetIndex].isUsed = true;
            this.responseData[targetIndex].registeredProduct = {
              productCode: productCode.trim(),
              registeredAt: registeredAt,
            };
            registeredCount++;
          }
        });

        this.$message.success(`${registeredCount}개 QR코드가 제품 코드 [${productCode.trim()}]로 등록되었습니다.`);
        this.closeProductRegisterModal();

      } catch (error) {
        console.error('제품 등록 실패:', error);
        await oneBtnDialog('등록 실패', '제품 등록에 실패했습니다. 다시 시도해주세요.', false);
      } finally {
        this.productRegisterModal.loading = false;
      }
    },

  },
};
</script>

<style lang="scss" scoped>
.search-filter-content{
  .mobile-wrap{
    display: flex;
    gap: 8px;
  }
  .mobile-no-wrap{
    display: flex;
  }
}

.generate-qr-button {
  margin-left: 8px;
}

.qr-format-info {
  margin-top: 8px;
  padding: 8px 12px;
  background-color: #f0f8ff;
  border-left: 4px solid #155DFC;
  border-radius: 4px;
  
  .text-muted {
    color: #666;
    font-size: 13px;
    
    i {
      margin-right: 6px;
      color: #155DFC;
    }
  }
}

.modal-title {
  color: #0A0A0A;
  text-align: center;
  font-family: Arial;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px; /* 100% */
  margin-left: auto;
  margin-right: auto;
}

.qr-detail-modal-content {
  padding: 0 20px;
  
  .qr-section {
    text-align: center;
    margin-bottom: 24px;
    
    .qr-section-title {
      color: #0A0A0A;
      text-align: center;
      font-family: Arial;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px; /* 150% */
      margin-top: 10px;
    }
    
    .qr-image-container {
      display: flex;
      justify-content: center;
      margin-bottom: 16px;
      
      .qr-code-image {
        width: 200px;
        height: 200px;
        border: 3px solid #000;
        border-radius: 8px;
        background-color: #ffffff;
      }
      
      .qr-code-placeholder {
        width: 200px;
        height: 200px;
        border: 3px solid #000;
        border-radius: 8px;
        background-color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        
        i {
          font-size: 80px;
          color: #000;
        }
      }
    }
    
    .qr-code-text {
      font-size: 16px;
      color: #155DFC;
      margin-bottom: 12px;
      font-family: 'Courier New', monospace;
    }
    
    .qr-link-url {
      padding:0 20px;
      font-size: 12px;
      color: #666;
      word-break: break-all;
      line-height: 1.4;
      margin-bottom: 20px;
    }
  }
  
  .qr-info-card {
    border: 1px solid rgba(0, 0, 0, 0.10);
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 24px;
    
    .info-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 0;
      
      &:last-child {
        border-bottom: none;
      }
      
      .info-label {
        color: #333;
        font-weight: 500;
        min-width: 120px;
      }
      
      .info-value {
        color: #666;
        text-align: right;
        flex: 1;
        &.status-badge{
          flex: 0;
        }
        
        &.has-product {
          color: #155DFC;
          font-weight: 500;
        }
        
        &.no-product {
          color: #ff9500;
          font-weight: 500;
        }
        
        &.usage-count {
          color: #333;
          font-weight: 600;
        }
        
        &.status-badge {
          padding: 4px 12px;
          border-radius: 16px;
          font-size: 12px;
          font-weight: 500;
          
          &.waiting {
            background-color: #ff9500;
            color: #fff;
          }
          
          &.active {
            background-color: #52c41a;
            color: #fff;
          }
        }
      }
    }
  }
  
  .modal-actions {
    display: flex;
    gap: 12px;
    margin-bottom: 15px;
    padding: 0 20px;
    
    .action-button {
      flex: 1;
      height: 48px;
      border-radius: 8px;
      font-weight: 600;
      
      &.secondary {
        border-radius: 8px;
        border: 1px solid rgba(0, 0, 0, 0.10);
        background: #FFF;

        &:hover {
          background: rgba(0, 0, 0, 0.05) !important;
          color: #0A0A0A;
          border-color: rgba(0, 0, 0, 0.10);
        }
      }
      
      &.primary {
        border-radius: 8px;
        background: #FDC700;
        color: #000;
        
        &:hover {
          background: rgba(255, 215, 0, 0.50) !important;
          color: #000;
        }
      }
      
      i {
        margin-right: 6px;
      }
    }
  }

  .linked-certificates-section {
    margin-top: 24px;

    .linked-certificates-header {
      margin-bottom: 16px;

      h4 {
        margin-bottom: 8px;
        color: #333;
        font-size: 16px;
        font-weight: 600;
      }

      p {
        margin: 0;
        color: #666;
        font-size: 14px;

        strong {
          color: #155DFC;
        }
      }
    }

    .linked-certificates-table {
      .ant-table {
        border: 1px solid #f0f0f0;
        border-radius: 8px;
      }
    }
  }
}

// 그룹 상세보기 모달 스타일
.group-detail-modal-content {
  padding: 0 10px;

  .group-summary-card {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 24px;

    .summary-row {
      display: flex;
      gap: 20px;
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 0;
      }

      .summary-item {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 12px;
        background: #fff;
        border-radius: 8px;

        &.full {
          flex: none;
          width: 100%;
        }

        .label {
          color: #666;
          font-size: 13px;
        }

        .value {
          font-weight: 600;
          font-size: 14px;
          color: #333;

          &.highlight {
            color: #155DFC;
            font-size: 16px;
          }

          &.text-success {
            color: #52c41a;
          }

          &.text-warning {
            color: #faad14;
          }

          &.text-primary {
            color: #155DFC;
          }
        }
      }
    }
  }

  .qr-detail-table-section {
    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;

      span {
        font-size: 15px;
        font-weight: 600;
        color: #333;
      }
    }

    .qr-code-text {
      font-family: 'Courier New', monospace;
      font-size: 13px;
      color: #155DFC;
    }

    :deep(.ant-table) {
      border: 1px solid #f0f0f0;
      border-radius: 8px;

      .ant-table-thead > tr > th {
        background: #fafafa;
        font-weight: 600;
      }
    }
  }

  .modal-footer-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;
    margin-bottom: 15px;
    padding-top: 16px;
    border-top: 1px solid #f0f0f0;
  }
}

// QR 15개 일괄 생성 모달 스타일
.qr-batch-modal-content {
  padding: 0 20px;

  .batch-info {
    background: #f8f9fa;
    border-radius: 10px;
    padding: 16px 20px;
    margin-bottom: 20px;

    .batch-info-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 6px 0;

      .info-label {
        color: #666;
        font-size: 14px;
      }

      .info-value {
        color: #333;
        font-weight: 500;
        font-size: 14px;

        &.highlight {
          color: #155DFC;
          font-weight: 600;
          font-size: 16px;
        }
      }
    }
  }

  .qr-batch-list {
    .qr-batch-list-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;

      span {
        font-size: 15px;
        font-weight: 600;
        color: #333;
      }
    }
  }
}

@media screen and (max-width:767px) {
  .date-selector-container,
  .ant-picker.ant-picker-range{
    width: 100% !important;
  }
  .search-filter-content .date-filter-container-wrapper{
    display: flex;
    flex-direction: column;
    width: 100%;
    .date-filter-container{
      flex-direction: row;
      border-radius: 0;
      border-bottom:0;
      .date-filter-item{
        width: 50%;
        border-bottom:0;
      }
    }
  }
  .container-fluid .row.justify-content-center{
    padding: 14px 14px 36px 14px !important;
  }
  .mainDiv{
    width: 100% !important;
  }
  .search-filter-title{
    margin-right: auto;
    width: auto;
    margin-left: 10px;
  }
  .search-filter-content .mobile-wrap{
    width: 100%;
  }
  .search-filter-content .search-select{
    width: 100px;
  }
  .search-filter-content .search-input-container{
    width: calc(100% - 100px);
    display: flex;
    justify-content: flex-start;
    input{
      width: 100%;
    }
  }
  .search-filter-content .date-filter-container{
    height: auto;
  }
  .search-filter-content .date-selector-container.custom{
    flex-direction: column;
    height: auto;
    align-items: center;
  }
  .search-filter-content .date-filter-container{
    flex-direction: column;
  }
  .search-filter-row{
    height: auto;
  }
  .search-filter-row,
  .search-filter-content{
    flex-direction: column;
    flex: none;
  }
  .card-header{
    margin: 0;
  }
  
  .generate-qr-button {
    margin-top: 8px;
    margin-left: 0;
    width: 100%;
  }
}

@media screen and (min-width:768px) and (max-width:1023px){
  .search-filter-title{
    width: 100%;
    justify-content: flex-start;
    margin-left: 20px;
  }
  
  .table-with-search .table-info-filter{
    flex-direction: column;
    width: 100%;
    .total-div{
      margin-right: auto;
    }
    .search-container{
      width: 100%;
      flex-direction: row;
      .search-select{
        margin-right: auto;
      }
      .search-div{
        flex-direction: row;
        width: 100%;
        input{
          width: calc(100% - 80px) !important;
        }
        .search-btn{
          min-width: 80px;
        }
      }
    }
  }
  .search-filter-row{
    flex-direction: column;
    height: auto;
    &:nth-of-type(2){
      .search-filter-content{
        flex-direction: column;
      }
      .search-filter-content{
        align-items: flex-start;
      }
      .date-selector-container.custom{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
      }
    }
  }
}

label {
  font-weight: 500;
}

// Expandable 테이블 스타일
.expandable-table {
  :deep(.ant-table-row-expand-icon-cell) {
    padding: 0 8px;
  }

  :deep(.ant-table-expand-icon-col) {
    width: 40px;
  }

  :deep(.ant-table-row-expand-icon) {
    border: 1px solid #155DFC;
    border-radius: 4px;

    &::before, &::after {
      background: #155DFC;
    }
  }

  :deep(.ant-table-expanded-row) {
    > td {
      background: #f8f9fa;
      padding: 16px !important;
    }
  }
}

// 그룹 테이블 내 요소 스타일
.qr-count-badge {
  display: inline-flex;
  align-items: center;
  background: #e6f7ff;
  color: #155DFC;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 500;
}

.usage-status {
  font-weight: 600;
  font-size: 14px;

  &.has-used {
    color: #52c41a;
  }

  &.no-used {
    color: #faad14;
  }
}

.linked-product {
  color: #155DFC;
  font-weight: 500;
}

.product-code-badge {
  display: inline-block;
  background: #f0f7ff;
  color: #155DFC;
  padding: 2px 8px;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  font-size: 12px;
}

// 펼치기 내부 QR 목록 스타일
.expanded-qr-list {
  .expanded-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding: 0 8px;

    span {
      font-size: 14px;
      font-weight: 600;
      color: #333;
    }
  }

  .text-muted {
    color: #999;
  }

  :deep(.ant-table) {
    background: transparent;

    .ant-table-thead > tr > th {
      background: #fff;
      font-weight: 600;
    }

    .ant-table-tbody > tr > td {
      background: #fff;
    }
  }
}

// 제품 등록 모달 스타일
.product-register-modal-content {
  padding: 0 10px;

  .qr-info-summary {
    background: #f8f9fa;
    border-radius: 10px;
    padding: 16px 20px;
    margin-bottom: 20px;

    .info-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 4px 0;

      .label {
        color: #666;
        font-size: 14px;
      }

      .value {
        color: #333;
        font-weight: 500;

        &.highlight {
          color: #155DFC;
          font-weight: 600;
          font-family: 'Courier New', monospace;
        }
      }
    }
  }

  .input-method-tabs {
    display: flex;
    gap: 12px;
    margin-bottom: 24px;

    .tab-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 16px;
      border: 2px solid #e8e8e8;
      border-radius: 10px;
      cursor: pointer;
      transition: all 0.2s;
      position: relative;

      i {
        font-size: 24px;
        color: #999;
        margin-bottom: 8px;
      }

      &:hover:not(.disabled) {
        border-color: #155DFC;
        background: #f0f7ff;

        i {
          color: #155DFC;
        }
      }

      &.active {
        border-color: #155DFC;
        background: #f0f7ff;

        i {
          color: #155DFC;
        }
      }

      &.disabled {
        cursor: not-allowed;
        opacity: 0.6;
      }

      .coming-soon {
        position: absolute;
        top: 8px;
        right: 8px;
        font-size: 10px;
        background: #ff9500;
        color: #fff;
        padding: 2px 6px;
        border-radius: 4px;
      }
    }
  }

  .input-form {
    .form-group {
      margin-bottom: 20px;

      .form-label {
        display: block;
        margin-bottom: 8px;
        font-weight: 500;
        color: #333;

        &.required::after {
          content: ' *';
          color: #ff4d4f;
        }
      }

      .form-hint {
        margin-top: 8px;
        font-size: 12px;
        color: #999;

        i {
          margin-right: 4px;
          color: #155DFC;
        }
      }
    }
  }

  .scan-area {
    .scan-placeholder {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 60px 20px;
      background: #f8f9fa;
      border: 2px dashed #ddd;
      border-radius: 10px;
      text-align: center;

      i {
        font-size: 48px;
        color: #ccc;
        margin-bottom: 16px;
      }

      p {
        color: #666;
        font-size: 16px;
        margin-bottom: 8px;
      }

      span {
        color: #999;
        font-size: 12px;
      }
    }
  }

  .qr-list-section {
    margin-top: 20px;
    margin-bottom: 20px;

    .qr-list-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;

      span {
        font-size: 14px;
        font-weight: 600;
        color: #333;
      }
    }

    .qr-list-container {
      max-height: 200px;
      overflow-y: auto;
      border: 1px solid #e8e8e8;
      border-radius: 8px;
      background: #fafafa;

      .qr-list-item {
        display: flex;
        align-items: center;
        padding: 8px 12px;
        border-bottom: 1px solid #f0f0f0;

        &:last-child {
          border-bottom: none;
        }

        .qr-index {
          width: 30px;
          font-size: 12px;
          color: #999;
          font-weight: 500;
        }

        .qr-code {
          flex: 1;
          font-family: 'Courier New', monospace;
          font-size: 13px;
          color: #333;
        }

        .qr-status {
          font-size: 11px;
          padding: 2px 8px;
          border-radius: 10px;

          &.pending {
            background: #fffbe6;
            color: #faad14;
          }

          &.registered {
            background: #f6ffed;
            color: #52c41a;
          }
        }
      }
    }
  }

  .modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 24px;
    margin-bottom: 15px;
    padding: 0;

    .action-button {
      min-width: 100px;
    }
  }
}
</style>

<style>
.hover-pointer{
  cursor: pointer;
}

.status-chip {
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  
  &.waiting {
    background-color: #fffbe6;
    color: #faad14;
    border: 1px solid #ffe58f;
  }
  
  &.partial {
    background-color: #e6f7ff;
    color: #155DFC;
    border: 1px solid #91d5ff;
  }
  
  &.completed {
    background-color: #f6ffed;
    color: #52c41a;
    border: 1px solid #b7eb8f;
  }
}
</style>
